(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products-slider"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      const slider = $('.product-slider');
      const slidesToShow = parseInt(slider.data('slides-to-show'));
      const showDots = slider.data('show-dots') === true;
      const infinite = slider.data('infinite') === true;
      const speed = parseInt(slider.data('speed'));
      const slidesToScroll = parseInt(slider.data('slides-to-scroll'));

      slider.slick({
        dots: showDots,
        infinite: infinite,
        speed: speed,
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToScroll,
        prevArrow: '<button type="button" aria-label="Previous Arrow" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M19.5866 3.59668L8.18359 14.9997L19.5896 26.3967L21.0746 24.9177L11.1566 14.9997L21.0776 5.08168L19.5866 3.59668Z" fill="#1D1D1D"/></svg></button>',
        nextArrow: '<button type="button" aria-label="Next Arrow" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M10.4134 26.4033L21.8164 15.0003L10.4104 3.60332L8.92541 5.08232L18.8434 15.0003L8.9224 24.9183L10.4134 26.4033Z" fill="#1D1D1D"/></svg></button>',
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: Math.min(3, slidesToShow)
            }
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: Math.min(2, slidesToShow)
            }
          },
          {
            breakpoint: 615,
            settings: {
              slidesToShow: 1,
              dots: true
            }
          }
        ]
      });
    });

    // After initialization, disable arrows if there are not enough slides
  slider.on('init', function(event, slick) {
    checkArrows(slick);
  });

  // Update arrow state on re-initialize or window resize
  slider.on('reInit afterChange', function(event, slick) {
    checkArrows(slick);
  });

  function checkArrows(slick) {
    if (slick.slideCount <= slick.options.slidesToShow) {
      $('.slick-prev, .slick-next').addClass('disabled');
    } else {
      $('.slick-prev, .slick-next').removeClass('disabled');
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selective-product-slider"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      const slider = $('.product-slider');
      const slidesToShow = parseInt(slider.data('slides-to-show'));
      const showDots = slider.data('show-dots') === true;
      const infinite = slider.data('infinite') === true;
      const speed = parseInt(slider.data('speed'));
      const slidesToScroll = parseInt(slider.data('slides-to-scroll'));

      slider.slick({
        dots: showDots,
        infinite: infinite,
        speed: speed,
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToScroll,
        prevArrow: '<button type="button" aria-label="Previous Arrow" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M19.5866 3.59668L8.18359 14.9997L19.5896 26.3967L21.0746 24.9177L11.1566 14.9997L21.0776 5.08168L19.5866 3.59668Z" fill="#1D1D1D"/></svg></button>',
        nextArrow: '<button type="button" aria-label="Next Arrow" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M10.4134 26.4033L21.8164 15.0003L10.4104 3.60332L8.92541 5.08232L18.8434 15.0003L8.9224 24.9183L10.4134 26.4033Z" fill="#1D1D1D"/></svg></button>',
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: Math.min(3, slidesToShow)
            }
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: Math.min(2, slidesToShow)
            }
          },
          {
            breakpoint: 615,
            settings: {
              slidesToShow: 1,
              dots: true
            }
          }
        ]
      });
    });

    // After initialization, disable arrows if there are not enough slides
  slider.on('init', function(event, slick) {
    checkArrows(slick);
  });

  // Update arrow state on re-initialize or window resize
  slider.on('reInit afterChange', function(event, slick) {
    checkArrows(slick);
  });

  function checkArrows(slick) {
    if (slick.slideCount <= slick.options.slidesToShow) {
      $('.slick-prev, .slick-next').addClass('disabled');
    } else {
      $('.slick-prev, .slick-next').removeClass('disabled');
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-collection"]) return;
  try {
    
    document.querySelectorAll('p').forEach(p => {
    if (p.textContent.trim() === '' && p.children.length === 0) {
      p.remove();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
